export const SizeMap = {
  sm: '1rem',
  md: '1.25rem',
  lg: '1.5rem',
  xl: '2.5rem',
  xxl: '3rem',
}

export const ScaleMap = {
  sm: 0.33,
  md: 0.4,
  lg: 0.5,
  xl: 0.75,
  xxl: 1,
}

export const CountryCodeShift: Record<string, number> = {
  ad: 48,
  ae: 5280,
  af: 96,
  ag: 144,
  ai: 192,
  al: 240,
  am: 288,
  an: 336,
  ao: 384,
  ar: 432,
  as: 480,
  at: 528,
  au: 576,
  aw: 624,
  az: 672,
  ba: 720,
  bb: 768,
  bd: 816,
  be: 864,
  bf: 912,
  bg: 960,
  bh: 1008,
  bi: 1056,
  bj: 1104,
  bm: 1152,
  bn: 1200,
  bo: 1248,
  br: 1296,
  bs: 1344,
  bt: 1392,
  bw: 1440,
  by: 1488,
  bz: 1536,
  ca: 1584,
  cc: 1632,
  cd: 1680,
  cf: 1728,
  cg: 1776,
  ch: 1824,
  ci: 1872,
  ck: 1920,
  cl: 1968,
  cm: 2016,
  cn: 2064,
  co: 2112,
  cr: 2160,
  cu: 2208,
  cv: 2256,
  cw: 2304,
  cx: 2352,
  cy: 2400,
  cz: 2448,
  de: 2496,
  dj: 2544,
  dk: 2592,
  dm: 2640,
  do: 2688,
  dz: 2736,
  ec: 2784,
  ee: 2832,
  eg: 2880,
  er: 2928,
  es: 2976,
  et: 3024,
  eu: 3072,
  fi: 3120,
  fj: 3168,
  fk: 3216,
  fm: 3264,
  fo: 3312,
  fr: 3360,
  ga: 3408,
  gb: 3456,
  gd: 3504,
  ge: 3552,
  gh: 3600,
  gi: 3648,
  gl: 3696,
  gm: 3744,
  gn: 3792,
  gq: 3840,
  gr: 3888,
  gt: 3936,
  gu: 3984,
  gw: 4032,
  gy: 4080,
  hk: 4128,
  hn: 4176,
  hr: 4224,
  ht: 4272,
  hu: 4320,
  id: 4368,
  ie: 4416,
  il: 4464,
  in: 4512,
  iq: 4560,
  ir: 4608,
  is: 4656,
  it: 4704,
  jm: 4752,
  jo: 4800,
  jp: 4848,
  ke: 4896,
  kg: 4944,
  kh: 4992,
  ki: 5040,
  km: 5088,
  kn: 5136,
  kp: 5184,
  kr: 5232,
  kw: 0,
  ky: 5328,
  kz: 5376,
  la: 5424,
  lb: 5472,
  lc: 5520,
  li: 5568,
  lk: 5616,
  lr: 5664,
  ls: 5712,
  lt: 5760,
  lu: 5808,
  lv: 5856,
  ly: 5904,
  ma: 5952,
  mc: 6000,
  md: 6048,
  me: 6096,
  mg: 6144,
  mh: 6192,
  mk: 6240,
  ml: 6288,
  mm: 6336,
  mn: 6384,
  mo: 6432,
  mr: 6480,
  ms: 6528,
  mt: 6576,
  mu: 6624,
  mv: 6672,
  mw: 6720,
  mx: 6768,
  my: 6816,
  mz: 6864,
  na: 6912,
  nc: 6960,
  ne: 7008,
  ng: 7056,
  ni: 7104,
  nl: 7152,
  no: 7200,
  np: 7248,
  nr: 7296,
  nz: 7344,
  om: 7392,
  pa: 7440,
  pe: 7488,
  pf: 7536,
  pg: 7584,
  ph: 7632,
  pk: 7680,
  pl: 7728,
  pn: 7776,
  pr: 7824,
  pt: 7872,
  pw: 7920,
  py: 7968,
  qa: 8016,
  ro: 8064,
  rs: 8112,
  ru: 8160,
  rw: 8208,
  sa: 8256,
  sc: 8304,
  sd: 8352,
  se: 8400,
  sg: 8448,
  sh: 8496,
  si: 8544,
  sk: 8592,
  sl: 8640,
  sm: 8688,
  sn: 8736,
  so: 8784,
  sr: 8832,
  ss: 8880,
  st: 8928,
  sv: 8976,
  sx: 9024,
  sy: 9072,
  sz: 9120,
  tc: 9168,
  td: 9216,
  tg: 9264,
  th: 9312,
  tj: 9360,
  tl: 9408,
  tm: 9456,
  tn: 9504,
  to: 9552,
  tr: 9600,
  tt: 9648,
  tv: 9696,
  tw: 9744,
  tz: 9792,
  ua: 9840,
  ug: 9888,
  us: 9936,
  uy: 9984,
  uz: 10032,
  va: 10080,
  ve: 10128,
  vg: 10176,
  vn: 10224,
  vu: 10272,
  ws: 10320,
  ye: 10368,
  za: 10416,
  zm: 10464,
  zw: 10512,
  ax: 10560,
  bl: 10608,
  bq: 10656,
  gf: 10704,
  gg: 10752,
  gp: 10800,
  gs: 10848,
  ic: 10896,
  im: 10944,
  io: 10992,
  je: 11040,
  mf: 11088,
  mq: 11136,
  pm: 11184,
  re: 11232,
  sj: 11280,
  yt: 11328,
  wf: 11376,
  tf: 11424,
}
